import { Authorize, TenantConfiguration } from "../../core/domain/models";
import { LoginRequest } from "../../core/domain/requests";
import {LoaderStatus} from "../../core/domain/enums/loader-enum";

export class GetTenantId {
  static readonly type = "[MasterLocationsGlobal] Get Tenant Id";
}

export class GetOrganizationUnitId {
  static readonly type = "[MasterLocationsGlobal] Get OrganizationUnit Id";
}

export class Login {
  static readonly type = "[MasterLocationsGlobal] login user";

  constructor(public payload: LoginRequest | undefined) {
  }
}

export class SetAuthorize {
  static readonly type = "[MasterLocationsGlobal] Set Authorize with new Token";

  constructor(public payload: Authorize | undefined) {
  }
}

export class GetTenantById {
  static readonly type = '[MasterLocationsGlobal] Get Tenant By Id';

  constructor(public payload: string ) {
  }
}
export class SetTenantId {
  static readonly type = "[MasterLocationsGlobal] Set Tenant Id";

  constructor(public payload: string | undefined) {
  }
}
export class  ViewCardSettings{
  static readonly type = '[Locations] View Card Settings';

  constructor(public payload: string | null) {}
}
export class ResetAllStates {
  static readonly type = '[App] Reset All States';
}

export class SetTenantConfigurations {
  static readonly type = "[MasterLocationsGlobal] Set Tenant Configurations";

  constructor(public payload: TenantConfiguration[] | undefined) {
  }
}

export class SetTenantConfigLoadStatus {
  static readonly type = "[MasterLocationsGlobal] Set Tenant Config Load Status";

  constructor(public payload: LoaderStatus) {
  }
}